<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters('auth', ['currentUser']),

    ...mapState('auth', ['showTerms']),

    showModal: {
      get() {
        return this.show || this.showTerms
      },
      set() {},
    },
  },

  methods: {
    ...mapActions('auth', [
      'logout',
      'acceptTermsAndConditions',
      'updateUserAgreementsModals',
    ]),

    closeModal() {
      this.updateUserAgreementsModals({ showTerms: false })

      if (this.currentUser && this.currentUser.terms_accepted === false) {
        this.logout()
      }
    },
  },
}
</script>

<template>
  <div>
    <b-modal
      v-model="showModal"
      title="Terms & Conditions"
      hide-footer
      header-class="col12 bg-primary text-white text-center closeButton"
      title-class="w-100"
      size="xl"
      modal-class="mt-5 pt-5"
      @close="closeModal"
      @hidden="closeModal"
    >
      <div class="px-5 py-2">
        <b-row>
          <b-col cols="12" class="info pb-4 text-left">
            <div>
              <p>
                Welcome to the Passenger Assist system, powered by Transreport
                for the Rail Delivery Group.
              </p>
              <p>
                You have been provided access to this system by your
                organisation. If you have any queries or questions please
                contact your organisation’s administrator.
              </p>
            </div>
          </b-col>
        </b-row>

        <b-row v-if="currentUser.terms_accepted === false">
          <b-col cols="12" class="d-flex justify-content-center">
            <b-button block class="ok-button reject-button" @click="closeModal">
              Reject
            </b-button>
            <b-button
              block
              variant="primary"
              class="ok-button"
              @click="acceptTermsAndConditions"
            >
              Accept
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<style lang="scss">
@import '@variables';

.modal-dialog {
  margin-bottom: 100px;
}

.info {
  font-size: 16px;
}

.reject-button {
  margin-top: 8px;
  margin-right: 43px;
  background-color: $gray-secondary !important;
  border-color: $gray-secondary !important;
}

.ok-button {
  width: 130px !important;
  font-weight: bold;
}
</style>
